import type { VariantDto } from '~/models/ListingProduct.api.model';

export const createBundlePriceIdToPlanIdMap = (
  variants: VariantDto[] = [],
): { [key: number]: number } => {
  if (!variants || (variants && variants.length === 0)) {
    return {};
  }

  const newMap: { [key: number]: number } = {};

  const bundlePrices = variants.flatMap(
    (variant) => variant.Prices.BundlePrices,
  );

  for (const bundlePrice of bundlePrices) {
    if (!bundlePrice) {
      continue;
    }

    if (bundlePrice.Plan?.PlanId) {
      newMap[bundlePrice.BundlePriceId] = bundlePrice.Plan?.PlanId;
    }
  }

  return newMap;
};
